import InternalLoginBg from '@/assets/img/banner-hero-gradient-squircles-abstract-d.jpg';
import LoginBg from '@/assets/img/multi_layer_data_art.png';
import logo from '@/assets/img/experian-logo.png';
import { default as OktaSignIn, WidgetOptions } from '@okta/okta-signin-widget';
import { useEffect, useRef } from 'react';
import { Tokens, OktaAuth } from '@okta/okta-auth-js';
import { OnAuthenticated } from '@ssar-app/okta-authn-react';
import { Alert, AlertIcon, Flex } from '@chakra-ui/react';
import { LOGIN_TYPE_ENUM } from '@ssar-app/domain';

const LoginInternal = (props: LoginProps) => {
  const { onSuccess, onError, isInternalLogin, oktaAuth, loginType } = props;
  const oktaConfig = oktaAuth.options;
  const widgetRef = useRef<HTMLDivElement>(null);
  const { issuer, clientId, redirectUri } = oktaConfig;

  const setSpellCheck = (inputType: 'text' | 'password') => {
    const userNameEle: HTMLElement | undefined | null = document
      .getElementById('login-panel')
      ?.querySelector(`input[type="${inputType}"]`);
    if (userNameEle) {
      userNameEle.spellcheck = false;
    }
  };

  useEffect(() => {
    const widgetConfig: WidgetOptions = {
      baseUrl: issuer?.split('/oauth2')[0],
      clientId,
      redirectUri,
      logo,
      i18n: {
        en: {
          'primaryauth.title':
            loginType === LOGIN_TYPE_ENUM.INTERNAL
              ? `Internal Login`
              : loginType === LOGIN_TYPE_ENUM.GDC
              ? `Gdc Login`
              : `Client Login`,
        },
      },
      colors: {
        brand: isInternalLogin ? '#af1685' : '#1d4f91',
      },
      authClient: oktaAuth,
      el: '#ssar-login-panel',
    };
    const widget = new OktaSignIn(widgetConfig);
    widget.on('afterRender', () => {
      setSpellCheck('text');
      setSpellCheck('password');
    });
    widget
      .showSignInToGetTokens({})
      .then((tokens?: Tokens) => {
        return onSuccess(oktaAuth, tokens);
      })
      .catch((err: Error) => onError(err));
    return () => {
      widget.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    clientId,
    isInternalLogin,
    issuer,
    oktaAuth,
    onError,
    onSuccess,
    redirectUri,
  ]);

  return <div id='ssar-login-panel' ref={widgetRef} />;
};

export type LoginProps = {
  oktaAuth: OktaAuth;
  isInternalLogin: boolean;
  loginType?: string;
  onSuccess: OnAuthenticated;
  onError: (error: Error) => void;
};

export const Login = (props: LoginProps) => {
  const { oktaAuth, loginType } = props;
  return (
    <>
      {!oktaAuth && (
        <Alert status='error'>
          <AlertIcon />
          Login configuration is missing.
        </Alert>
      )}

      {oktaAuth && (
        <Flex
          id='login-panel'
          alignItems='center'
          justifyContent='center'
          style={{
            backgroundImage: `url('${
              loginType === LOGIN_TYPE_ENUM.INTERNAL ? InternalLoginBg : LoginBg
            }')`,
          }}
        >
          <LoginInternal {...props} />
        </Flex>
      )}
    </>
  );
};
